import { createContext, useContext } from 'react';
import { UseWalletConnectResult } from './types';

export const WalletConnectContext = createContext<
  UseWalletConnectResult | undefined
>(undefined);

/**
 * Hook to access WalletConnect context.
 * @returns UseWalletConnectResult
 */
export function useWalletConnect(): UseWalletConnectResult {
  const context = useContext(WalletConnectContext);
  if (!context) {
    throw new Error(
      'useWalletConnect must be used within TransactionBuilderWalletConnectProvider'
    );
  }
  return context;
}
